// import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetransportoffice() {



const cardData = {


    keyword: "Pune Transport Office",

    headingDescription: "SSK Logistic provides organized transportation support for businesses searching for a Pune transport office for goods movement, freight booking, cargo transportation, truck arrangements, logistics coordination, commercial deliveries, and industrial transportation requirements. Businesses can coordinate transportation needs from Pune for local, regional, and interstate destinations through structured booking, route planning, vehicle coordination, cargo movement, and delivery scheduling. SSK Logistic supports manufacturers, distributors, retailers, wholesalers, warehouses, corporate businesses, traders, and industrial units with practical transportation solutions designed around shipment type, vehicle requirements, destination, loading needs, and delivery schedules, making it easier to coordinate regular as well as one-time business consignments.",

    topPlaces: [
        {
            title: "Pune to Chakan Transport Booking",
            description: "SSK Logistic supports transport booking from Pune to Chakan for manufacturing units, automotive businesses, industrial suppliers, warehouses, and factories. Goods, machinery, components, raw materials, and finished products can be coordinated according to dispatch schedules and destination requirements."
        },
        {
            title: "Pune to Bhiwandi Goods Transport Office",
            description: "Businesses moving goods from Pune toward Bhiwandi can coordinate transportation for warehouse inventory, commercial products, industrial materials, and distribution consignments. SSK Logistic assists with booking, vehicle coordination, route planning, and delivery scheduling."
        },
        {
            title: "Pune to Mumbai Cargo Transportation",
            description: "Cargo transportation from Pune to Mumbai supports manufacturers, distributors, retailers, traders, and corporate businesses moving commercial and industrial consignments. SSK Logistic coordinates suitable transportation according to cargo type, destination, route distance, and required delivery schedule."
        },
        {
            title: "Pune to Nashik Freight Booking",
            description: "Freight booking from Pune to Nashik is suitable for businesses transporting machinery, industrial goods, commercial inventory, raw materials, and distribution stock. SSK Logistic coordinates vehicle requirements and delivery arrangements based on shipment size and destination needs."
        },
        {
            title: "Pune to Surat Transport Service",
            description: "SSK Logistic supports transportation from Pune to Surat for businesses moving commercial inventory, textile-related goods, industrial supplies, machinery, and freight consignments. Route and vehicle arrangements can be planned according to cargo requirements and scheduled delivery timelines."
        },
        {
            title: "Pune to Ahmedabad Truck Booking",
            description: "Truck booking from Pune to Ahmedabad helps businesses arrange interstate movement of larger commercial and industrial consignments. SSK Logistic coordinates suitable vehicle capacity, loading requirements, route planning, and destination delivery for planned shipments."
        },
        {
            title: "Pune to Hyderabad Goods Transportation",
            description: "Goods transportation from Pune to Hyderabad supports long-distance movement of machinery, industrial materials, commercial products, warehouse stock, and business cargo. SSK Logistic provides coordinated transportation planning based on shipment characteristics and delivery requirements."
        },
        {
            title: "Pune to Indore Commercial Transport",
            description: "Commercial transport from Pune to Indore helps retailers, distributors, manufacturers, and traders move inventory, equipment, finished goods, and industrial materials. SSK Logistic coordinates transportation according to shipment volume, route distance, and destination schedules."
        },
        {
            title: "Pune to Bengaluru Logistics Transportation",
            description: "Logistics transportation from Pune to Bengaluru supports businesses moving industrial materials, machinery, components, commercial products, and warehouse inventory. SSK Logistic coordinates long-distance vehicle arrangements and delivery planning for interstate business consignments."
        },
        {
            title: "Pune to Delhi NCR Freight Transportation",
            description: "Freight transportation from Pune to Delhi NCR is suitable for businesses requiring organized long-distance movement of industrial goods, commercial inventory, machinery, and larger consignments. SSK Logistic coordinates vehicle planning, route requirements, and delivery schedules."
        }
    ],

    "services": [
        {
            "name": "Transport Office Pune",
            "description": "SSK Logistic supports businesses searching for a transport office Pune option for goods movement, freight transportation, cargo booking, truck arrangements, and commercial deliveries. Transportation requirements can be coordinated according to destination, shipment type, vehicle needs, and delivery schedule."
        },
        {
            "name": "Transport Company Office Pune",
            "description": "A transport company office Pune requirement can be supported by SSK Logistic for businesses arranging commercial goods movement, industrial freight, cargo transportation, and interstate deliveries. Booking and transportation coordination can be planned around individual shipment requirements."
        },
        {
            "name": "Transport Service Office Pune",
            "description": "SSK Logistic provides transport service office Pune support for customers coordinating goods transportation, truck movement, cargo deliveries, and freight requirements. Transportation arrangements can be structured according to cargo quantity, destination, route distance, and expected delivery schedule."
        },
        {
            "name": "Goods Transport Office Pune",
            "description": "Businesses searching for a goods transport office Pune can coordinate with SSK Logistic for movement of raw materials, finished products, commercial inventory, machinery, and equipment. Vehicle and route arrangements are planned according to shipment and delivery requirements."
        },
        {
            "name": "Logistics Office Pune",
            "description": "SSK Logistic supports logistics office Pune requirements for transportation planning, cargo coordination, freight movement, warehouse transfers, and commercial distribution. Businesses can coordinate local as well as interstate transportation according to their operational schedules."
        },
        {
            "name": "Transport Booking Office Pune",
            "description": "Transport booking office Pune services from SSK Logistic help businesses coordinate vehicle requirements for goods, freight, cargo, machinery, and commercial consignments. Booking arrangements can be planned around destination, shipment size, vehicle suitability, and delivery timelines."
        },
        {
            "name": "Cargo Transport Office Pune",
            "description": "SSK Logistic provides cargo transport office Pune support for businesses requiring transportation of industrial materials, commercial products, warehouse stock, machinery, and other cargo. Transportation coordination includes practical route and vehicle planning based on shipment requirements."
        },
        {
            "name": "Freight Transport Office Pune",
            "description": "Freight transport office Pune requirements can be coordinated through SSK Logistic for heavier commercial and industrial consignments. Vehicle selection, loading requirements, route distance, and destination delivery schedules can be considered while planning freight transportation."
        },
        {
            "name": "Transportation Office Pune",
            "description": "SSK Logistic supports transportation office Pune requirements for businesses coordinating local, regional, and interstate goods movement. Services can include transportation booking, vehicle coordination, cargo movement, route planning, and delivery scheduling."
        },
        {
            "name": "Truck Booking Office Pune",
            "description": "Truck booking office Pune services from SSK Logistic assist businesses requiring suitable trucks for commercial and industrial cargo. Truck arrangements can be coordinated according to cargo quantity, loading requirements, destination, route distance, and planned delivery schedules."
        },
        {
            "name": "Goods Booking Office Pune",
            "description": "SSK Logistic supports goods booking office Pune requirements for businesses arranging transportation of commercial inventory, raw materials, machinery, finished goods, and warehouse stock. Booking and transportation plans are aligned with cargo characteristics and delivery requirements."
        },
        {
            "name": "Transport Agency Pune",
            "description": "As a transport agency Pune businesses can approach, SSK Logistic supports goods movement, freight transportation, cargo delivery, truck booking, and industrial transportation. Services can be coordinated for recurring business routes as well as individual shipments."
        },
        {
            "name": "Transport Service Provider Pune",
            "description": "SSK Logistic serves as a transport service provider Pune businesses can coordinate with for commercial goods, industrial cargo, freight, machinery, and warehouse transportation. Route planning and vehicle coordination are structured around specific shipment and delivery requirements."
        },
        {
            "name": "Logistics Service Provider Pune",
            "description": "Logistics service provider Pune requirements can be supported by SSK Logistic through transportation planning, cargo coordination, freight movement, warehouse transfers, and commercial distribution. Businesses can arrange logistics services for local and interstate destinations."
        },
        {
            "name": "Freight Booking Pune",
            "description": "Freight booking Pune services from SSK Logistic help businesses arrange transportation for larger industrial and commercial consignments. Booking requirements can be coordinated around cargo dimensions, shipment quantity, vehicle suitability, route distance, and delivery schedules."
        },
        {
            "name": "Cargo Booking Pune",
            "description": "SSK Logistic supports cargo booking Pune requirements for businesses transporting machinery, industrial materials, commercial products, equipment, and warehouse inventory. Transportation arrangements can be organized according to cargo size, destination, route, and delivery requirements."
        },
        {
            "name": "Goods Transportation Pune",
            "description": "Goods transportation Pune services from SSK Logistic support manufacturers, distributors, retailers, wholesalers, and industrial businesses moving products and materials between factories, warehouses, markets, and customer destinations. Vehicle and route planning are coordinated around shipment needs."
        },
        {
            "name": "Truck Transport Pune",
            "description": "Truck transport Pune services from SSK Logistic provide businesses with organized vehicle movement for commercial goods, industrial materials, machinery, freight, and cargo. Truck requirements can be planned according to load size, destination, route distance, and scheduled delivery."
        },
        {
            "name": "Transport Company Near Pune",
            "description": "Businesses searching for a transport company near Pune can use SSK Logistic for local, regional, and interstate goods transportation. The service supports factories, warehouses, commercial businesses, distributors, traders, and industrial units with coordinated transportation arrangements."
        },
        {
            "name": "Transport Office Near Pune",
            "description": "A transport office near Pune requirement can be supported by SSK Logistic for customers coordinating goods booking, freight movement, cargo transportation, truck arrangements, and commercial deliveries. Transportation plans can be customized according to destination and shipment requirements."
        },
        {
            "name": "Logistics Company Pune",
            "description": "SSK Logistic operates as a logistics company Pune businesses can approach for organized cargo movement, freight transportation, warehouse transfers, industrial logistics, and commercial distribution. Transportation arrangements can be coordinated for both recurring and individual business shipments."
        },
        {
            "name": "Commercial Transport Office Pune",
            "description": "Commercial transport office Pune services from SSK Logistic help retailers, distributors, wholesalers, traders, and corporate businesses coordinate transportation for commercial inventory and business consignments. Booking and delivery schedules can be structured around operational requirements."
        },
        {
            "name": "Industrial Transport Office Pune",
            "description": "SSK Logistic supports industrial transport office Pune requirements for factories and manufacturing units moving machinery, components, raw materials, equipment, and finished goods. Transportation arrangements can be aligned with production schedules and dispatch requirements."
        },
        {
            "name": "Road Transport Office Pune",
            "description": "Road transport office Pune services from SSK Logistic provide businesses with practical coordination for ground transportation across local, regional, and interstate routes. Goods, freight, cargo, machinery, and commercial inventory can be planned for road movement."
        },
        {
            "name": "Professional Transport Office Pune",
            "description": "SSK Logistic supports professional transport office Pune requirements through organized booking, vehicle coordination, route planning, cargo movement, and delivery scheduling. The service is suitable for manufacturers, distributors, warehouses, corporate businesses, and commercial customers."
        }
    ],

    "tableData": [
        ["Transport Office Pune", "Transport Company Office Pune"],
        ["Transport Service Office Pune", "Goods Transport Office Pune"],
        ["Logistics Office Pune", "Transport Booking Office Pune"],
        ["Cargo Transport Office Pune", "Freight Transport Office Pune"],
        ["Transportation Office Pune", "Truck Booking Office Pune"],
        ["Goods Booking Office Pune", "Transport Agency Pune"],
        ["Transport Service Provider Pune", "Logistics Service Provider Pune"],
        ["Freight Booking Pune", "Cargo Booking Pune"],
        ["Goods Transportation Pune", "Truck Transport Pune"],
        ["Transport Company Near Pune", "Transport Office Near Pune"],
        ["Logistics Company Pune", "Commercial Transport Office Pune"],
        ["Industrial Transport Office Pune", "Road Transport Office Pune"],
        ["Professional Transport Office Pune", "Pune Transport Office"]
    ],

    whychoose: [
        {
            WhyChooseheading: "Centralized Transportation Coordination",
            WhyChoosedescription: "SSK Logistic helps businesses coordinate transportation requirements through structured booking, vehicle planning, route scheduling, cargo movement, and delivery arrangements from Pune to multiple business destinations."
        },
        {
            WhyChooseheading: "Support for Goods and Freight",
            WhyChoosedescription: "Manufacturers, distributors, traders, retailers, and industrial businesses can coordinate transportation for commercial goods, freight consignments, machinery, raw materials, finished products, and warehouse inventory."
        },
        {
            WhyChooseheading: "Practical Booking Assistance",
            WhyChoosedescription: "Transportation booking can be organized around shipment type, cargo volume, vehicle requirements, destination, route distance, loading conditions, and expected delivery schedules for smoother business logistics coordination."
        },
        {
            WhyChooseheading: "Local and Interstate Coverage",
            WhyChoosedescription: "SSK Logistic supports transportation within Pune and surrounding industrial areas as well as longer routes connecting Pune with major commercial and manufacturing destinations across Maharashtra and other states."
        },
        {
            WhyChooseheading: "Industrial Transport Support",
            WhyChoosedescription: "Factories and industrial units can coordinate movement of machinery, components, raw materials, equipment, and finished products with transportation plans aligned to production and dispatch requirements."
        },
        {
            WhyChooseheading: "Commercial Cargo Coordination",
            WhyChoosedescription: "Retailers, wholesalers, distributors, and corporate businesses can arrange commercial transportation for inventory transfers, warehouse movements, market deliveries, and recurring distribution requirements."
        },
        {
            WhyChooseheading: "Flexible Vehicle Planning",
            WhyChoosedescription: "SSK Logistic coordinates suitable vehicle arrangements according to cargo characteristics and shipment volume, supporting truck transportation, freight movement, cargo deliveries, and larger business consignments."
        },
        {
            WhyChooseheading: "Business-Focused Logistics Support",
            WhyChoosedescription: "The service is structured around the practical requirements of business transportation, including pickup coordination, route planning, cargo movement, delivery scheduling, and support for recurring logistics operations."
        }
    ]

};

















const faqData = [
    {
        question: "What transportation services can I arrange through SSK Logistic in Pune?",
        answer: "SSK Logistic helps businesses coordinate commercial and industrial goods transportation from Pune to various destinations, with arrangements based on cargo details, vehicle capacity, route requirements, and delivery schedules."
    },
    {
        question: "Can SSK Logistic organize goods transportation from Pune to other cities?",
        answer: "Cargo movement can be coordinated from Pune to destinations including Mumbai, Nashik, Nagpur, Ahmedabad, Surat, Indore, Bengaluru, Hyderabad, Chennai, Delhi, Jaipur, and other locations across India."
    },
    {
        question: "What kind of cargo can be transported through SSK Logistic?",
        answer: "Businesses can discuss transportation for suitable consignments such as industrial materials, machinery, equipment, commercial stock, packaged products, raw materials, finished goods, supplies, and warehouse-related shipments."
    },
    {
        question: "Does SSK Logistic support regular transportation from Pune?",
        answer: "Companies with recurring transportation requirements can plan regular goods movement around their preferred routes, shipment frequency, cargo volume, vehicle capacity, pickup schedules, and delivery timelines."
    },
    {
        question: "How does SSK Logistic plan a transportation vehicle for cargo?",
        answer: "The vehicle requirement is considered using factors such as shipment weight, dimensions, quantity, volume, loading conditions, cargo type, route distance, and final delivery destination."
    },
    {
        question: "Can SSK Logistic arrange Pune to Mumbai goods transportation?",
        answer: "Yes, businesses can coordinate transportation from Pune to Mumbai for commercial inventory, industrial materials, machinery, equipment, supplies, packaged goods, and other suitable consignments."
    },
    {
        question: "Does SSK Logistic provide transportation from Pune to destinations outside Maharashtra?",
        answer: "Interstate goods transportation can be planned toward states such as Gujarat, Madhya Pradesh, Karnataka, Telangana, Tamil Nadu, Rajasthan, Delhi, and other parts of India according to the shipment requirements."
    },
    {
        question: "Can industrial companies use SSK Logistic for cargo transportation?",
        answer: "Manufacturers, distributors, suppliers, warehouses, and industrial businesses can utilize transportation support for moving raw materials, finished products, equipment, machinery, commercial stock, and other business goods."
    },
    {
        question: "Can transportation arrangements be customized for different business shipments?",
        answer: "Yes, the transportation plan can be discussed according to the pickup location, destination, cargo specifications, shipment quantity, loading requirements, vehicle type, delivery schedule, and frequency of movement."
    },
    {
        question: "What details should I share with SSK Logistic for a transportation enquiry?",
        answer: "Providing the pickup area, delivery destination, type of goods, approximate weight or quantity, dimensions when required, vehicle preference, loading details, and expected delivery timeframe helps in planning the transportation requirement."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Kunal Gawande",
        feedback: "We contacted SSK Logistic for moving industrial supplies from Pune to Ahmedabad. The team reviewed our shipment requirements and coordinated the transportation arrangement in a clear and systematic manner.",
        rating: 5
    },
    {
        id: 2,
        name: "Miss. Shreya Mahajan",
        feedback: "Our business needed regular goods movement from Pune, and SSK Logistic was convenient to coordinate with. They understood our cargo requirements and arranged transportation according to our planned route.",
        rating: 5
    }
];














    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Logistics Company Pune",
            link: "Logistics-Company-Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Best Logistics Companies in Pune",
            link: "Best-Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Top Logistics Companies in Pune",
            link: "Top-Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Logistics in Pune",
            link: "Logistics-in-Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Transport Company in Pune",
            link: "Transport-Company-in-Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Logistics Companies in Pune",
            link: "Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Transporters in Pune",
            link: "Transporters-in-Pune",
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Pune Transport Office",
            link: "Pune-Transport-Office",
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Best Logistics Company in Pune",
            link: "Best-Logistics-Company-in-Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Goods Transport Services in Pune",
            link: "Goods-Transport-Services-in-Pune",
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Transportation Services for Industrial",
            link: "Transportation-Services-for-Industrial",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune Transport Service for Company",
            link: "Pune-Transport-Service-for-Company",
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Industrial Transport Company in Pune",
            link: "Industrial-Transport-Company-in-Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Supply Chain Management Company in Pune",
            link: "Supply-Chain-Management-Company-in-Pune",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Cargo Transportation Company in Pune",
            link: "Cargo-Transportation-Company-in-Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Commercial Transportation Services in Pune",
            link: "Commercial-Transportation-Services-in-Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Container Transportation Company in Pune",
            link: "Container-Transportation-Company-in-Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Third Party Logistics Company in India",
            link: "Third-Party-Logistics-Company-in-India",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Transport Service",
            link: "Pune-to-Mumbai-Transport-Service",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune to Bangalore Transport Service",
            link: "Pune-to-Bangalore-Transport-Service",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Hyderabad Transport Service",
            link: "Pune-to-Hyderabad-Transport-Service",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Chennai Transport Service",
            link: "Pune-to-Chennai-Transport-Service",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Delhi Transport Service",
            link: "Pune-to-Delhi-Transport-Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Ahmedabad Transport Service",
            link: "Pune-to-Ahmedabad-Transport-Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Surat Transport Service",
            link: "Pune-to-Surat-Transport-Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Nashik Transport Service",
            link: "Pune-to-Nashik-Transport-Service",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Nagpur Transport Service",
            link: "Pune-to-Nagpur-Transport-Service",
        },
        {
            place: "/images/keyword/28.jpg",
            text: "Pune to Kolhapur Transport Service",
            link: "Pune-to-Kolhapur-Transport-Service",
        },
    ];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Transport Office",
  "image": "https://ssklogistics.in/assets/images/pune-transport-office.webp",
  "description": "SSK Logistics provides transportation and logistics coordination for businesses searching for a Pune Transport Office to manage goods movement, cargo transportation, freight requirements and commercial shipment arrangements. Transport Office Pune services can assist businesses with transportation enquiries, vehicle coordination, shipment planning and scheduled goods movement across local, regional and interstate routes. A transport company office Pune can support businesses that require organized communication for commercial transportation requirements, while transport service office Pune can help coordinate vehicle and route requirements based on cargo type and destination. Goods transport office Pune services can be suitable for manufacturers, distributors, wholesalers, retailers and other businesses that regularly move commercial goods. Logistics office Pune requirements can involve shipment coordination, transportation planning and business logistics support. Transport booking office Pune services can assist customers with arranging vehicles for planned goods transportation, while cargo transport office Pune can support commercial cargo movement and shipment coordination. Freight transport office Pune services can be suitable for businesses handling larger or recurring consignments, and transportation office Pune can assist with general commercial movement requirements. Truck booking office Pune services can help businesses arrange suitable truck transportation according to cargo volume, vehicle capacity, route and delivery schedule. SSK Logistics focuses on practical transportation coordination and responsive logistics support for businesses requiring dependable goods movement from Pune to nearby and interstate destinations.",
  "brand": {
    "@type": "Brand",
    "name": "SSK Logistics"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Contact for Transport Service Pricing",
    "availability": "https://schema.org/InStock",
    "url": "https://ssklogistics.in/pune-transport-office"
  }
};




    return (
        <div>

<Helmet>
  <title>
    Pune Transport Office | Goods, Cargo, Freight & Truck Booking Services | +91 9876543210
  </title>

  <meta
    name="description"
    content="SSK Logistics provides transport office support in Pune for goods transport, cargo, freight, logistics coordination, vehicle arrangements and truck booking."
  />

  <meta
    name="keywords"
    content="Pune Transport Office, transport office pune, transport company office pune, transport service office pune, goods transport office pune, logistics office pune, transport booking office pune, cargo transport office pune, freight transport office pune, transportation office pune, truck booking office Pune, goods transport company Pune, goods transportation Pune, cargo transportation Pune, freight transportation Pune, truck transport Pune, truck booking Pune, commercial transport office Pune, industrial transport office Pune, logistics service office Pune, transport service provider Pune, transportation service provider Pune, freight service provider Pune, cargo service provider Pune, logistics company Pune, transport company Pune, goods transport services Pune, commercial transportation Pune, industrial transportation Pune, business transportation Pune, local transport Pune, regional transport Pune, interstate transport Pune, B2B transport Pune, logistics coordination Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>








            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/8.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >SSK Logistics
                                : {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="cab-service-list">
                                {cardData.services.map((service, index) => (
                                    <div className="cab-service-row" key={index}>
                                        <div className="cab-service-details">
                                            <h4>{service.name}</h4>
                                            <span className="cab-service-line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="cab-service-arrow">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div> */}
                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>


                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>SSK Logistics</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">




                                        <div className="row twm-faq-section-1 m-b30">


                                            <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                                <div className="twm-faq-info-wrap">

                                                    <div className="section-head left">
                                                        <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For SSK Logistics </h2>
                                                    </div>


                                                    <div className="twm-faq-info">
                                                        <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                            <FaqSection
                                                                title=""
                                                                subtitle=""
                                                                items={faqData}
                                                            />

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919876543210 " className="pc-call">+91 9876543210 </a>
                                        </div>


                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919876543210 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919876543210 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:info@ssklogistics.in" className="pc-email">
                                            info@ssklogistics.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>SSK Logistics</strong><br />
                                            ViOffice no. 109 first Floor, Ashoka Plaza, above dominos Pizza, Beside Hyatt Hotel, Viman Nagar, Pune- 411014




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetransportoffice;